import React from 'react';
import dogAgeIcon from '../../../../../../assets/icons/ugc-dog-age.svg';
import dogBreedIcon from '../../../../../../assets/icons/ugc-dog-breed.svg';
import dogNameIcon from '../../../../../../assets/icons/ugc-dog-name.svg';
import thumbsUpIcon from '../../../../../../assets/icons/ugc-thumbs-up.svg';
import { Label } from '../../../../../../components/ArticleAdviceCardHeader/components/Label';
import { numberOfVotesLabelFormatter } from '../../../../../../utils/numberOfVotesLabelFormatter';
import { Box } from '../../../../../../wag-react/next-components/box';
import { Flex } from '../../../../../../wag-react/next-components/Flex';
import { theme } from '../../../../../../wag-react/themes/base-theme';
export type TrainingUGCHeaderProps = {
  age: string;
  breed: string;
  name: string;
  numLikes?: number;
  ugcTypeLabel: {
    alt: string;
    icon: string;
    type: string;
  };
};
export const TrainingUGCHeader = ({
  age,
  breed,
  name,
  numLikes,
  ugcTypeLabel
}: TrainingUGCHeaderProps) => <Flex borderTop={[0, `1px solid ${theme.colors.whisper}`]} borderRadius={[0, '12px 12px 0 0']} py={3} px="16px" backgroundColor={theme.colors.whiteSmoke} width={1} data-sentry-element="Flex" data-sentry-component="TrainingUGCHeader" data-sentry-source-file="index.tsx">
    <Flex flex="1" flexDirection={['column', 'row']} justifyContent="space-between" alignItems={['flex-start', null, 'center']} pr={[0, 0, '20px']} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <Label display={name ? 'flex' : 'none'} src={dogNameIcon} value={name} alt="Dog nametag icon" textProps={{
      fontSize: '20px'
    }} data-sentry-element="Label" data-sentry-source-file="index.tsx" />
      <Label alt="Dog breed icon" src={dogBreedIcon} value={breed} data-sentry-element="Label" data-sentry-source-file="index.tsx" />
      <Label alt="Dog age icon" src={dogAgeIcon} value={age} data-sentry-element="Label" data-sentry-source-file="index.tsx" />
      <Label alt={ugcTypeLabel.alt} src={ugcTypeLabel.icon} value={ugcTypeLabel.type} data-sentry-element="Label" data-sentry-source-file="index.tsx" />

      {/* "numLikes &&" doesn't render as expected if numLikes is 0 */}
      {numLikes !== undefined && <Label display={['none', 'flex']} src={thumbsUpIcon} value={numberOfVotesLabelFormatter(numLikes)} p={0} alt="Thumbs up icon" />}
    </Flex>

    {/* "numLikes &&" doesn't render as expected if numLikes is 0 */}
    {numLikes !== undefined && <>
        <Box display={['block', 'none']} border="1px solid #E5E5E5" mr="20px" />

        <Box>
          <Label display={['flex', 'none']} src={thumbsUpIcon} value={numberOfVotesLabelFormatter(numLikes)} p={0} alt="Thumbs up icon" />
        </Box>
      </>}
  </Flex>;